import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ margin: "auto", height: "95vh", overflow: "scroll" }}>
      <div style={{ margin: "auto" }} className="flex flex-col w-6/12">
        <h2>Privacy Policy</h2>
        <p>
          Informativa sul trattamenti dei dati personali ai sensi degli artt. 13
          e 14 Reg UE 679/2016 (GDPR)
        </p>
        <ol>
          <li>
            <h3>TITOLARE E RESPONSABILE DEL TRATTAMENTO</h3>
            <p>
              Titolare del trattamento è IBC S.r.l., con sede legale in Piazza
              Borromeo n. 12 Milano, C.F.: 09694390965, in persona del legale
              rappresentante p.t. Pace Daniele, C.F.: PCADNL85B28H501B, email:
              info@ibc.srl, sito internet:{" "}
              <a href="www.easytaxassistant.it">www.easytaxassistant.it</a>{" "}
              (d’ora in avanti “sito internet”). Il titolare del trattamento si
              riserva la nomina di responsabili del trattamento ai sensi
              dell’art. 28 GDPR.
            </p>
          </li>
          <li>
            <h3>FINALITÀ DEL TRATTAMENTO</h3>
            <p>
              I dati sono raccolti e trattati esclusivamente per le seguenti
              finalità:
            </p>
            <ol>
              <li>Gestione degli appuntamenti con la clientela;</li>
              <li>Gestione del form di contatto presente sul sito internet;</li>
              <li>Marketing diretto.</li>
            </ol>
          </li>
          <li>
            <h3>TIPOLOGIA DEL DATI PERSONALI TRATTATI</h3>
            <p>
              I dati raccolti e trattati allo scopo di adempiere le finalità di
              cui al punto 2 appartengono alle seguenti tipologie:
            </p>
            <ul>
              <li>
                dati personali semplici (art. 4 GDPR), quali ad esempio:
                recapiti di posta elettronica, numero di telefono, dati
                identificativi e anagrafici, dati relativi al settore di
                attività ricoperto, al nome, al tipo di attività effettuata e
                alle finalità perseguite.
              </li>
            </ul>
          </li>
          <li>
            <h3>BASE GIURIDICA DEL TRATTAMENTO (art. 6 GDPR)</h3>
            <p>
              La base giuridica del trattamento dei dati, quanto alla finalità
              elencata al punto 2 A e B, è costituita dal contratto stipulato
              tra titolare del trattamento e interessato attraverso il sito
              internet, nei modi e tempi indicati nelle condizioni generali di
              vendita. Per quanto concerne la finalità di al punto 2, lett. C,
              la base giuridica del trattamento è costituita dal legittimo
              interesse del titolare del trattamento, costituito dalla vendita
              di prodotti e servizi similari e/o migliorativi rispetto a quelli
              già offerti dal titolare del trattamento e fruiti
              dall’interessato. In caso di tipologie di trattamento non
              rientranti nel citato legittimo interesse, il titolare del
              trattamento procederà soltanto sulla base del consenso
              dell’interessato.
            </p>
          </li>
          <li>
            <h3>DESTINATARI DEL TRATTAMENTO</h3>
            <p>
              I dati personali raccolti e trattati saranno comunicati a soggetti
              terzi rispetto al titolare del trattamento e ai responsabili del
              trattamento soltanto qualora strettamente necessario al
              perseguimento delle finalità convenute al punto 2 o nel caso in
              cui lo impongano norme di legge.
            </p>
            <p>
              Tali destinatari trattano i dati dei Clienti in qualità di
              titolari, responsabili o incaricati del trattamento a seconda
              delle circostanze.
            </p>
            <p>
              Il titolare del trattamento si avvale, per lo svolgimento della
              propria opera e degli incarichi a lui assegnati, di collaboratori
              che agiscono in qualità di responsabili del trattamento e
              presentano garanzie sufficienti per mettere in atto misure
              tecniche e organizzative adeguate al rispetto degli obblighi di
              cui al GDPR.
            </p>
            <h3>5 a) CATEGORIE DI DESTINATARI</h3>
            <p>
              Per destinatari ai sensi del punto 6 si intendono, in via
              esemplificativa: provider di servizi cloud, avvocati, consulenti
              del lavoro, commercialisti, pubbliche amministrazioni.
            </p>
          </li>
          <li>
            <h3>TRASFERIMENTO DEI DATI ALL’ESTERO</h3>
            <p>
              Qualora si riveli necessario trasferire i dati al di fuori del
              territorio italiano, il titolare del trattamento si impegna a
              limitarne il trasferimento all’interno dell’Unione Europea.
            </p>
            <p>
              6 a) Il trasferimento di dati a Paesi Terzi rispetto all’Unione
              europea avverrà soltanto qualora strettamente necessario e
              soltanto nei confronti di provider che offrono garanzie adeguate
              di tutela dei dati personali.
            </p>
          </li>
          <li>
            <h3>DURATA DEL TRATTAMENTO</h3>
            <p>
              I dati raccolti saranno conservati fino al perseguimento delle
              finalità indicate al punto 2 e comunque non oltre 10 anni dal
              raggiungimento delle medesime, per fini contabili e di difesa in
              giudizio, ai sensi degli artt. 2220 c.c. e 2946 c.c.
            </p>
          </li>
          <li>
            <h3>DIRITTI DELL’INTERESSATO</h3>
            <p>
              L’interessato potrà esercitare i seguenti diritti, rivolgendosi
              direttamente al titolare del trattamento:
            </p>
            <ul>
              <li>diritto di accesso ai sensi dell’art. 15 GDPR;</li>
              <li>diritto di rettifica ai sensi dell’art. 16 GDPR;</li>
              <li>
                diritto alla cancellazione (oblio) ai sensi dell’art. 17 GDPR;
              </li>
              <li>
                diritto di limitazione di trattamento ai sensi dell’art. 18
                GDPR;
              </li>
              <li>diritto alla portabilità ai sensi dell’art. 20 GDPR;</li>
              <li>diritto di opposizione ai sensi dell’art. 21 GDPR;</li>
              <li>
                diritto di revocare il consenso in qualsiasi momento ai sensi
                dell’art. 7 GDPR, senza che ciò pregiudichi la liceità del
                trattamento basata sul consenso prestato prima della revoca;
              </li>
            </ul>
            <p>
              I diritti elencati potranno essere esercitati inviando una
              comunicazione al titolare del trattamento tramite i recapiti di
              cui al punto 1.
            </p>
            <p>
              I diritti elencati potranno subire limitazioni nei casi
              espressamente previsti dall’art. 2-undecies d.lgs. 196/2003.
            </p>
          </li>
          <li>
            <h3>DIRITTO DI OPPOSIZIONE (art. 21 GDPR)</h3>
            <p>
              L’interessato ha il diritto di opporsi in qualsiasi momento, per
              motivi connessi alla sua situazione particolare, al trattamento
              dei dati personali che lo riguardano ai sensi dell’articolo 6,
              paragrafo 1, lettere e) o f). Il titolare del trattamento si
              astiene dal trattare ulteriormente i dati personali, salvo che
              egli dimostri l’esistenza di motivi legittimi cogenti per
              procedere al trattamento che prevalgono sugli interessi, sui
              diritti e sulle libertà dell’interessato oppure per
              l’accertamento, l’esercizio o la difesa di un diritto in sede
              giudiziaria.
            </p>
          </li>
          <li>
            <h3>
              OBBLIGO DI NOTIFICA IN CASO DI RETTIFICA O CANCELLAZIONE DEI DATI
              PERSONALI O LIMITAZIONE DEL TRATTAMENTO (art. 19 GDPR)
            </h3>
            <p>
              Il titolare del trattamento comunica a ciascuno dei destinatari
              cui sono stati trasmessi i dati personali le eventuali rettifiche
              o cancellazioni o limitazioni del trattamento effettuate a norma
              dell’articolo 16, dell’articolo 17, paragrafo 1, e dell’articolo
              18 GDPR, salvo che ciò si riveli impossibile o implichi uno sforzo
              sproporzionato. Il titolare del trattamento comunica
              all’interessato tali destinatari qualora richiesto da
              quest’ultimo.
            </p>
          </li>
          <li>
            <h3>COMUNICAZIONI</h3>
            <p>
              Il Titolare del trattamento si impegna a comunicare eventuali
              violazioni concernenti i dati personali dell’interessato
              all’Autorità Garante per la protezione dei dati personali e, in
              caso la violazione sia suscettibile di presentare un rischio
              elevato per i diritti e le libertà delle persone, all’interessato,
              a norma degli artt. 33 e 34 GDPR.
            </p>
          </li>
          <li>
            <h3>
              DIRITTO DI PROPORRE RECLAMO ALL’AUTORITÀ GARANTE (art. 77 GDPR)
            </h3>
            <p>
              Fatto salvo ogni altro ricorso amministrativo o giurisdizionale,
              l’interessato che ritenga il trattamento che lo riguarda violi il
              contenuto del GDPR ha il diritto di proporre reclamo all’Autorità
              garante per la protezione dei dati personali, segnatamente nello
              Stato membro dell’Unione Europea in cui risiede abitualmente,
              lavora, oppure del luogo ove si è verificata la presunta
              violazione.
            </p>
          </li>
          <li>
            <h3>DIRITTO A PROPORRE RICORSO GIURISDIZIONALE (art. 19 GDPR)</h3>
            <p>
              Fatto salvo ogni altro ricorso amministrativo o extragiudiziale
              disponibile, compreso il diritto di proporre reclamo a un’autorità
              di controllo ai sensi dell’articolo 77 GDPR, ogni interessato ha
              il diritto di proporre un ricorso giurisdizionale effettivo
              qualora ritenga che i diritti di cui gode siano stati violati a
              seguito di un trattamento. Le azioni nei confronti del titolare
              del trattamento o del responsabile del trattamento sono promosse
              dinanzi alle autorità giurisdizionali dello Stato membro in cui il
              titolare del trattamento o il responsabile del trattamento ha uno
              stabilimento. In alternativa, tali azioni possono essere promosse
              dinanzi alle autorità giurisdizionali dello Stato membro
              dell’Unione Europea in cui l’interessato risiede abitualmente,
              salvo che il titolare del trattamento o il responsabile del
              trattamento sia un’autorità pubblica di uno Stato membro
              nell’esercizio dei pubblici poteri.
            </p>
          </li>
          <li>
            <h3>COOKIE TECNICI</h3>
            <p>
              Il sito internet utilizza cookie tecnici, che sono necessari alla
              navigazione all'interno dello stesso in quanto permettono
              l’esecuzione di funzioni essenziali. I cookie tecnici non possono
              essere disattivati poiché ciò comporterebbe un malfunzionamento
              del sito.
            </p>
          </li>
          <p>
            Questo sito web utilizza i cookie. Utilizziamo i cookie per
            personalizzare contenuti ed annunci, per fornire funzionalità dei
            social media e per analizzare il nostro traffico. Condividiamo
            inoltre informazioni sul modo in cui utilizzi il nostro sito con i
            nostri partner che si occupano di analisi dei dati web, pubblicità e
            social media, i quali potrebbero combinarle con altre informazioni
            che hai fornito loro o che hanno raccolto dal tuo utilizzo dei loro
            servizi.
          </p>
          <p>
            I cookie sono piccoli file di testo che possono essere utilizzati
            dai siti web per rendere più efficiente l'esperienza per l'utente.
          </p>

          <p>
            Dichiarazione Cookie aggiornata l'ultima volta il 05/07/23 da
            Cookiebot:
          </p>
          <h3>Necessari (1)</h3>
          <p>
            I cookie necessari contribuiscono a rendere fruibile il sito web
            abilitandone funzionalità di base quali la navigazione sulle pagine
            e l'accesso alle aree protette del sito. Il sito web non è in grado
            di funzionare correttamente senza questi cookie.
          </p>

          <table style={{ fontSize: "small", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                  Nome
                </th>
                <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                  Fornitore
                </th>
                <th
                  style={{
                    padding: "8px",
                    border: "1px solid #ddd",
                    width: "40%",
                  }}
                >
                  Scopo
                </th>
                <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                  Scadenza
                </th>
                <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                  Tipo
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  CookieConsent
                </td>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  Cookiebot
                </td>
                <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                  <small>
                    Memorizza lo stato del consenso ai cookie dell'utente per il
                    dominio corrente
                  </small>
                </td>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  1 anno
                </td>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  HTTP Cookie
                </td>
              </tr>
            </tbody>
          </table>

          <h3>Preferenze (1)</h3>
          <p>
            I cookie di preferenza consentono al sito web di memorizzare
            informazioni che ne influenzano il comportamento o l'aspetto, quali
            la lingua preferita o la località nella quale ti trovi.
          </p>

          <table style={{ fontSize: "small", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                  Nome
                </th>
                <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                  Fornitore
                </th>
                <th
                  style={{
                    padding: "8px",
                    border: "1px solid #ddd",
                    width: "40%",
                  }}
                >
                  Scopo
                </th>
                <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                  Scadenza
                </th>
                <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                  Tipo
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  wp-wpml_current_language
                </td>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  easytaxassistant.it
                </td>
                <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                  <small>
                    Determina il prefisso internazionale calcolato sulla base
                    dell'indirizzo IP dell'utente. Utilizzato per determinare
                    quale lingua deve essere utilizzata per utenti.
                  </small>
                </td>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  Session
                </td>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  HTTP Cookie
                </td>
              </tr>
            </tbody>
          </table>
        </ol>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
